<template>
  <div
    class="loading-spinner-wrapper flex-row flex-all-center"
    :class="{ inside: range === 'inside', 'shade—mode': shadeMode }"
  >
    <img v-if="type === 'loading'" src="@assets/images/loading.svg" class="loading" />
  </div>
</template>

<script>
  export default {
    name: 'Loading',
    props: {
      type: String,
      shadeMode: { type: Boolean, default: true },
      range: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
  .loading-spinner-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100001;
    background: transparent;
    &.shade—mode {
      background: rgba(255, 255, 255, 0);
    }

    &.inside {
      position: absolute;
      z-index: 10;
    }
  }
  .loading {
    width: 44px;
  }
</style>
